import { Stack } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { Typography, Select, MenuItem, SelectChangeEvent } from "@mui/material"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { SelectOption } from "../../../shopsTypes"

const useStyles = makeStyles()((theme) => ({
    baseColor: {
        color: theme.palette.text.primary,
    },
}))

type SelectColorProps = {
    list: SelectOption[]
    selectedTabletSize: SelectOption | undefined
    handleSelectTabletSize: (el: SelectOption) => void
}

export const SelectTabletSize = ({ list, selectedTabletSize, handleSelectTabletSize }: SelectColorProps) => {
    const { classes } = useStyles()

    const handleChange = (event: SelectChangeEvent) => {
        const value = list.find((el) => el.value === event.target.value)
        value && handleSelectTabletSize(value)
    }

    return (
        <Stack direction="row" alignItems="center" spacing="2rem">
            <LocalizedStrict id="merchant-shop-form-hardware-packages-tablet-size">
                <Typography variant="body2" className={classes.baseColor}>
                    Tablet size:
                </Typography>
            </LocalizedStrict>
            <Select label="" value={selectedTabletSize?.value} onChange={handleChange}>
                {list?.map((element) => {
                    return (
                        <MenuItem key={element.label} value={element.value}>
                            {element.label}
                        </MenuItem>
                    )
                })}
            </Select>
        </Stack>
    )
}
